export default Object.freeze({
    BidConfigurationDetails: 1,
    PayCodeeSelection: 2,
    EmployeeSelection: 3,
    AbsenceThreshold: 4,
    CalendarRules: 5,
    BidScheduling: 6,
});
